<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <template v-slot:header>
                <h5>Detail Tipe Barang</h5>
            </template>
            <div class="detail-data-wrapper mb-4">
                <h6 class="form-title">DATA TIPE</h6>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Tipe Barang</b-col>
                    <b-col v-if="tipeBarang.name != null">{{tipeBarang.name}}</b-col>
                    <b-col v-else>-</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Merk Barang</b-col>
                    <b-col v-if="tipeBarang.merk.name != null">{{tipeBarang.merk.name}}</b-col>
                    <b-col v-else>-</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Jenis Barang</b-col>
                    <b-col v-if="tipeBarang.jenis.name != null">{{tipeBarang.jenis.name}}</b-col>
                    <b-col v-else>-</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Kelompok Barang</b-col>
                    <b-col v-if="tipeBarang.kelompok.name != null">{{tipeBarang.kelompok.name}}</b-col>
                    <b-col v-else>-</b-col>
                </b-row>

                <b-row class="mb-2" v-if="!tipeBarang.hasTahun">
                    <b-col cols="4" class="detail-data-label">Harga Resmi</b-col>
                    <b-col>
                        <span v-if="tipeBarang.harga == null">{{$helper.addThousandSeparator(tipeBarang.harga[0].harga)}} </span>
                        <span v-else>Rp. {{$helper.addThousandSeparator(tipeBarang.harga[0].harga)}} </span>
                    </b-col>
                </b-row>
                <b-row class="mb-2" v-if="!tipeBarang.hasTahun">
                    <b-col cols="4" class="detail-data-label">Harga LN</b-col>
                    <b-col>
                        <span v-if="tipeBarang.harga == null">{{$helper.addThousandSeparator(tipeBarang.harga[1].harga)}} </span>
                        <span v-else>Rp. {{$helper.addThousandSeparator(tipeBarang.harga[1].harga)}} </span>
                    </b-col>
                </b-row>
                <b-row class="mb-2" v-if="!tipeBarang.hasTahun">
                    <b-col cols="4" class="detail-data-label">Harga RR</b-col>
                    <b-col>
                        <span v-if="tipeBarang.harga == null">{{$helper.addThousandSeparator(tipeBarang.harga[2].harga)}} </span>
                        <span v-else>Rp. {{$helper.addThousandSeparator(tipeBarang.harga[2].harga)}} </span>
                    </b-col>
                </b-row>
                <b-row class="mb-2" v-if="!tipeBarang.hasTahun">
                    <b-col cols="4" class="detail-data-label">Harga Barang Baru</b-col>
                    <b-col>
                        <span v-if="tipeBarang.harga == null">{{$helper.addThousandSeparator(tipeBarang.hargaBarangBaru)}} </span>
                        <span v-else>Rp. {{$helper.addThousandSeparator(tipeBarang.hargaBarangBaru)}} </span>
                    </b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Status</b-col>
                    <b-col v-if="tipeBarang.isActive == true">AKTIF</b-col>
                    <b-col v-else>NON-AKTIF</b-col>
                </b-row>
            </div>
            <div class="detail-data-wrapper mb-4" v-if="tipeBarang.hasTahun ">
                <h6 class="form-title">HARGA TAHUN / GENERASI</h6>
                <b-table bordered hover show-empty :fields="fieldHarga" :busy="isBusy" :items="tipeBarang.tahun" responsive class="mb-3">
                    <template v-slot:table-busy>
                        <div class="text-center text-danger my-2">
                            <b-spinner class="align-middle"></b-spinner>
                            <strong>  Loading data...</strong>
                        </div>
                    </template>
                    <template v-slot:empty>
                        Tidak ada data harga tahun.
                    </template>
                    <template v-slot:cell(hargaElektronik)="row">
                        <div class="text-right no wrap" v-if="row.item.harga == null">{{$helper.addThousandSeparator(row.item.harga)}} </div>
                        <div class="text-right no wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.harga)}} </div>
                    </template>
                    <template v-slot:cell(hargaBpkb)="row">
                        <div class="text-right no wrap" v-if="row.item.hargaBpkb == null">{{$helper.addThousandSeparator(row.item.hargaBpkb)}} </div>
                        <div class="text-right no wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.hargaBpkb)}} </div>
                    </template>
                    <template v-slot:cell(hargaKendaraan)="row">
                        <div class="text-right no wrap" v-if="row.item.hargaKendaraan == null">{{$helper.addThousandSeparator(row.item.hargaKendaraan)}} </div>
                        <div class="text-right no wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.hargaKendaraan)}} </div>
                    </template>
                    <template v-slot:cell(isActive)="row">
                        <span v-if="row.item.isActive == true" class="badge badge-success">Aktif</span>
                        <span v-else-if="row.item.isActive == false" class="badge badge-danger">Non Aktif</span>
                    
                    </template>
                </b-table>
            </div>
            <div class="d-flex">
                <div class="detail-edit-btn mr-2">
                    <b-button variant="pgiBtn" name="tipeBarangEditBtn" @click="editTipeBarang">Ubah data umum</b-button>
                </div>
                <div class="detail-edit-btn mr-2">
                    <b-button variant="pgiBtn" name="ubahHarga" @click="editHarga">Ubah Harga</b-button>
                </div>
                <div class="detail-edit-btn mr-2">
                    <b-button variant="pgiBtn" name="ubahHarga" @click="editKondisi">Ubah Kondisi</b-button>
                </div>
                <div class="detail-edit-btn mr-2">
                    <b-button variant="pgiBtn" name="ubahHarga" @click="editSuratEdaran">Surat Edaran</b-button>
                </div>
                <div class="detail-edit-btn mr-2">
                    <b-button variant="pgiBtn" name="ubahHarga" @click="editFotoPendukung">Foto Pendukung</b-button>
                </div>
            </div>
            
            <b-modal id="modal-edit-harga" size="lg" title="Edit Harga Tipe Barang" no-close-on-esc no-close-on-backdrop>
                <b-form id="updateHargaForm">
                    <MHarga :rincian="tipeBarang" :jenisPinjaman="tipeBarang.jenis" @hasSubmit="init()"/>
                </b-form>
                <template v-slot:modal-footer="{ ok, cancel }">
                    <b-button variant="secondary" name="closeEditHargaBtn" @click="cancel()">
                        Cancel
                    </b-button>
                </template>
            </b-modal>

            <b-modal id="modal-edit-kondisi" size="lg" title="Edit Kondisi Tipe Barang" no-close-on-esc no-close-on-backdrop>
                <b-form id="updateKondisiForm">
                    <MKondisi :rincian="tipeBarang" />
                </b-form>
                <template v-slot:modal-footer="{ ok, cancel }">
                    <b-button variant="secondary" name="closeEditHargaBtn" @click="cancel()">
                        Cancel
                    </b-button>
                </template>
            </b-modal>

            <b-modal id="modal-edit-fotoPendukung" size="lg" title="Edit Foto Pendukung" no-close-on-esc no-close-on-backdrop>
                <b-form >
                    <MFotoPendukung :rincian="tipeBarang" />
                </b-form>
                <template v-slot:modal-footer="{ ok, cancel }">
                    <b-button variant="secondary" name="closeEditHargaBtn" @click="cancel()">
                        Cancel
                    </b-button>
                </template>
            </b-modal>

            <b-modal id="modal-edit-surat-edaran" title="Edit Surat Edaran" no-close-on-esc no-close-on-backdrop>
                <MSuratEdaran :rincian="tipeBarang" />
                <template v-slot:modal-footer="{ ok, cancel }">
                    <b-button variant="secondary" name="closeEditHargaBtn" @click="cancel()">
                        Cancel
                    </b-button>
                </template>
            </b-modal>
        </b-card>
    </div>
</template>

<script>
import Vue from 'vue'
import VueFormulate from '@braid/vue-formulate'

Vue.use(VueFormulate)
import MHarga from './MHarga.vue'
import MKondisi from './MKondisi.vue'
import MFotoPendukung from './MFotoPendukung.vue'
import MSuratEdaran from './MSuratEdaran.vue'

export default {
    name: 'detail-tipe-barang',
    components: {
        MHarga,
        MKondisi,
        MFotoPendukung,
        MSuratEdaran,
    },
    data(){
        return{
            id: null,
            initStatus: 0,
            isBusy: true,
            tipeBarang: {
                merk: {
                    id: null,
                    name: null
                },
                jenis: {
                    id: null,
                    name: null
                }
            },
            pdf: {
                urlPDF : {
                    fileList:[]
                }
            },
            pdf1: {
                urlPDF : {
                    fileList:[]
                }
            },
            url : [],
            url1 : [],
            url2 : [],
            merkBarang: "",
            jenisBarang: "",
            kondisiBarang: [],
            hargaTahun: [],
            fieldHargaKendaraan: [
                { key: "tahun", label: "Tahun / Generasi", sortable:true},
                { key: "hargaBpkb", label: "Harga BPKB", sortable: true},
                { key: "hargaKendaraan", label: "Harga Kendaraan", sortable: true},
                { key: "isActive", label: "Status", sortable: true}
            ],
            fieldHargaElektronik: [
                { key: "tahun", label: "Tahun / Generasi", sortable:true},
                { key: "hargaElektronik", label: "Harga Elektronik", sortable:true},
                { key: "isActive", label: "Status", sortable: true}
            ],
            fields: [
                { key: "name", label: "Grade Barang", sortable:true},
                { key: "klasifikasi", label: "Klasifikasi", sortable:true},
                { key: "hargaMaksimal", label: "Harga Maksimal", sortable: true},
                { key: "nominalAngka", label: "Nominal Angka", sortable: true},
                { key: "nominalPersen", label: "Nominal Persen", sortable: true},
                { key: "keterangan", label: "Keterangan", sortable: true},
            ],
            fieldHarga: [],
        }
    }, 
    methods:{

        //----------------- Fungsi Inisialisasi -----------------

        init(){
            this.initStatus = 0
            this.id = this.$route.params.id

            let getSingleTipeBarang = this.$axios.get(`barang-tipe-v2/${this.id}`).then(response => {
                this.tipeBarang = response.data

                if(this.tipeBarang.suratEdaran.length != 0){
                    for(var file of this.tipeBarang.suratEdaran){
                        if(file.jenis == "tipe" || file.jenis == null){
                                this.url.push({
                                id: file.id,
                                url:file.filepath,
                            })
                        }
                        if(file.jenis == "tahun"){
                                this.url1.push({
                                id: file.id,
                                url:file.filepath,
                            })
                        }
                        if(file.jenis == "kondisi"){
                                this.url2.push({
                                id: file.id,
                                url:file.filepath,
                            })
                        }
                    }

                }


                if(this.tipeBarang.jenisPinjaman.name =='Kendaraan'){
                    this.fieldHarga = this.fieldHargaKendaraan
                }else if(this.tipeBarang.jenisPinjaman.name == 'Elektronik'){
                    this.fieldHarga = this.fieldHargaElektronik
                }
                if (this.tipeBarang.kondisi.length == 0 && this.tipeBarang.merk.id != null) {
                    this.$axios.get(`barang-merk/kondisi/${this.tipeBarang.merk.id}`).then(response => {
                        this.tipeBarang.kondisi = response.data
                        this.toggleBusy();
                    })
                    .catch(error => {
                        console.log(error)
                        console.log(error.response.data.reason)
                        this.$helper.parseError(this, error)
                    })
                }
                else this.toggleBusy()

                let msg = this.$helper.getFlash()
                this.$helper.toastSucc(this, msg)
            })

            Promise.all([getSingleTipeBarang]).then(() => {
                this.initStatus = 1
            })
            .catch(error => {
                console.log(error)
                this.initStatus = -1
            })
        },
        
        //----------------- Fungsi Pindah Halaman dan Fungsi Lain -----------------

        toggleBusy() {
            if (this.isBusy == true) this.isBusy = false
            else this.isBusy = true
        },

        editTipeBarang(){
            this.$router.push({path: `${this.$route.path}/edit`});
        },
        editHarga(){
            this.$bvModal.show("modal-edit-harga")
        },
        editKondisi(){
            this.$bvModal.show("modal-edit-kondisi")
        },
        editSuratEdaran(){
            this.$bvModal.show("modal-edit-surat-edaran")
        },
        editFotoPendukung(){
            this.$bvModal.show("modal-edit-fotoPendukung")
        },

        removeSETahun(){
            for(var file of this.pdf1.urlPDF.files){
            let idx = this.pdfNewVal1.findIndex(item => item.name == file.name)
            if(idx == -1){
                if(file.path.id != undefined){
                    this.hapusSE.push(file.path.id)
                }
            }
            }

            this.pdf1.urlPDF.files = this.pdfNewVal1
            this.pdfRecords1 = this.pdfNewVal1
            this.$bvModal.hide("modal-hapus-se-tahun")
        },

    },

    watch:{
        "pdf1.urlPDF.files" : function(newVal){
            //Hapus SE
            if(this.pdfRecords1.length > newVal.length){
                this.pdf1.urlPDF.files = this.pdfRecords1
                this.pdfNewVal1 = newVal
                this.$bvModal.show("modal-hapus-se-tahun")
            }
            //Tambah SE
            else {
            let pdf = []
            let i = 0
            for(var file of this.pdf1.urlPDF.files){
                let name = file.name
                pdf.push(file)
            }
            this.input.filePDFTahun = pdf
            this.pdfRecords1 = pdf
            }
            
        },

        "pdf1.file.fileList" : function(newVal){
            let Pdfbase64 = []
            let i = 0
            for(var file of this.pdf1.file.fileList){
                let name =file.name
                Pdfbase64.push(file)
            }
            this.input.filePDFTahun = Pdfbase64
        },
    },
    
    created(){
        this.init()
    }
}
</script>
